import React from 'react'

interface TitleTextProps {
  containerClassName?: string
  titleClassName?: string
  textClassName?: string
  titleTag?: 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  textTag?: 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  title: string
  text: string | React.ReactNode
  titleImage?: string
  children?: React.ReactNode
  imageClass?: string
}

const TitleText = ({
  containerClassName,
  titleClassName,
  textClassName,
  titleTag = 'p',
  textTag = 'p',
  title,
  text,
  children,
  titleImage,
  imageClass,
}: TitleTextProps) => {
  const TitleTag = titleTag
  const TextTag = textTag

  return (
    <div className={containerClassName}>
      <div className="flex items-center gap-x-2">
        <TitleTag className={titleClassName}>{title}</TitleTag>
        {titleImage && <img className={imageClass} src={titleImage} alt={title} />}
      </div>
      <TextTag className={textClassName}>{text}</TextTag>
      {children}
    </div>
  )
}

export default TitleText
